export * from './SelectedMaterialsFloatingCounter.types';
export { default as SelectedMaterialsFloatingCounter } from './SelectedMaterialsFloatingCounter';
